<template>
  <div :key="selectedProject">
    <v-dialog
      scrollable
      v-model="show"
    >
      <v-card>
        <v-card-title class="pb-0 px-4">
          <v-tabs
            v-model="tabModel"
            @change="onTabChange"
          >
            <v-tab
              v-for="(tab, tabKey) in classifications"
              :key="tabKey"
            >
              {{ tab.Classification_Title }}
            </v-tab>
          </v-tabs>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-4">
          <v-row>
            <v-col>
              {{ summaryDatesLength }}
              {{ summaryTitleExists }}
              {{ canSave }}
            </v-col>
            <v-col>
              <RangeDatePickerMenu
                v-model="dateRange"
                showButtons
              />
            </v-col>
            <v-col>
              <v-text-field
                dense
                hide-details
                v-model="summaryTitle"
                label="Title"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="classifications.length">
            <v-col cols="12" sm="5" md="4" lg="3">
              <v-list dense>
                <v-subheader>{{filteredEmployee.length ? 'EMPLOYEE': ''}}</v-subheader>
                <v-list-item-group
                  v-model="selectedEmployee"
                  color="primary"
                >
                  <v-list-item
                    class="px-2"
                    v-for="(empl, emplKey) in filteredEmployee"
                    :key="emplKey"
                  >
                    <v-list-item-icon class="mx-1">
                      <v-icon>mdi-account-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{empl.Full_Name}}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
            <v-col cols="12" sm="7" md="8" lg="9" v-if="filteredEmployee.length && selectedEmployee >= 0" :key="`tab-${tabModel}-${selectedEmployee}-${updateKey}`">
              <v-subheader>METRICS</v-subheader>
              <v-row>
                <v-col cols="12" sm="6" md="4"
                  v-for="(metric, metricKey) in currentMetrics"
                  :key="metricKey"
                >
                  <div class="elevation-2">
                    <div class="d-flex items-baseline black--text pa-3">
                      {{ metric.Title }}
                      <v-spacer></v-spacer>
                      <v-btn small icon color="primary"
                        @click="showMetricDescr(metric.PR_Matrix_ID)"
                      >
                        <v-icon
                          color="primary"
                        >
                          mdi-information
                        </v-icon>
                      </v-btn>
                    </div>
                    <v-divider></v-divider>
                    <div class="pa-3">
                      <v-text-field
                        dense
                        hide-details
                        label="Value"
                        v-model="metric.valueByEmployee[selectedEmployeeID]"
                        @input="checkValues"
                      ></v-text-field>
                      <v-row
                        class="pt-3"
                        v-if="showInformationForMetric === metric.PR_Matrix_ID"
                      >
                        <v-col>
                          <v-textarea
                            auto-grow
                            rows="1"
                            disabled
                            label="Essensce"
                            :value="metric.Essensce"
                          ></v-textarea>
                          <v-textarea
                            auto-grow
                            rows="1"
                            disabled
                            label="Limit Value"
                            :value="metric.Limit_Value"
                          ></v-textarea>
                        </v-col>
                        <v-col>
                          <v-textarea
                            auto-grow
                            rows="1"
                            disabled
                            label="Calculation"
                            :value="metric.Calculation"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="show = false"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="canSave"
            color="success"
            @click="saveMetricSummary"
          >
            {{ summary ? 'Update' : 'Save' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'MetricDetails',
  components: {
    RangeDatePickerMenu: () => import('@/components/global/RangeDatePickerMenu.vue')
  },
  props: {
    value: {
      required: false,
      default: false
    },
    summary: {
      required: false,
      default: null
    }
  },
  data () {
    return {
      tabModel: 0,
      employeeAtTheProject: [],
      classifications: [],
      selectedEmployee: 0,
      showInformationForMetric: null,
      dates: [],
      summaryTitle: null,
      datePickerMenu: false,
      updateKey: 0,
      hasValues: false
    }
  },
  mounted () {
    if (!this.classifications.length) this.getMetricClassifications()
  },
  computed: {
    dateRange: {
      get () {
        return this.dates
      },
      set (value) {
        this.dates = [...value].sort((a, b) => {
          const dA = new Date(a)
          const dB = new Date(b)
          if (+dA > +dB) return 1
          if (+dA < +dB) return -1
          return 0
        })
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    selectedProject () {
      const projectID = this.$store.getters.getSelectedProject
      this.getEmployeeAtTheProject(projectID)
      return projectID
    },
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    currentMetrics () {
      return this.classifications[this.tabModel].listOfMetrics.filter(item => item.Enabled)
    },
    selectedEmployeeID () {
      return this.filteredEmployee[this.selectedEmployee].Employee_ID
    },
    filteredEmployee () {
      return this.employeeAtTheProject.filter(item => this.classifications[this.tabModel].assigns.indexOf(item.Status_ID) > -1).sort((a, b) => {
        if (a.Full_Name < b.Full_Name) return -1
        if (a.Full_Name > b.Full_Name) return 1
        return 0
      })
    },
    summaryDatesLength () {
      return !!this.dates.length
    },
    summaryTitleExists () {
      return !!this.summaryTitle
    },
    canSave () {
      return this.hasValues && this.summaryTitleExists && this.summaryDatesLength
    }
  },
  methods: {
    checkValues () {
      this.hasValues = false
      let res = false
      for (let i = 0; i < this.classifications.length; i++) {
        const listOfMetrics = this.classifications[i].listOfMetrics
        for (let j = 0; j < listOfMetrics.length; j++) {
          const values = listOfMetrics[j].valueByEmployee
          for (const key in values) {
            if (values[key]) {
              res = true
              break
            }
          }
          if (res) break
        }
        if (res) break
      }
      this.hasValues = res
    },
    showMetricDescr (id) {
      if (this.showInformationForMetric === id) this.showInformationForMetric = null
      else this.showInformationForMetric = id
    },
    setEmployeeMetricsValue (values) {
      for (let i = 0; i < this.classifications.length; i++) {
        const assigns = this.classifications[i].assigns
        for (let j = 0; j < this.classifications[i].listOfMetrics.length; j++) {
          for (let h = 0; h < this.employeeAtTheProject.length; h++) {
            const statusID = this.employeeAtTheProject[h].Status_ID
            let val = null
            if (assigns.indexOf(statusID) > -1) {
              const id = this.employeeAtTheProject[h].Employee_ID
              if (values) {
                val = values.filter(item => {
                  const prMatrixId = this.classifications[i].listOfMetrics[j].PR_Matrix_ID
                  return item.PR_Matrix_ID === prMatrixId && item.Employee_ID === id
                })
              }
              if (val && val[0]) {
                val = val[0].Value || null
              }
              this.classifications[i].listOfMetrics[j].valueByEmployee[id] = val
            }
          }
        }
      }
      if (this.summary) {
        this.summaryTitle = this.summary.Name
        this.dates = [this.summary.Date_From, this.summary.Date_To]
      }
      this.updateKey++
    },
    onTabChange (e) {
      if (!this.filteredEmployee[this.selectedEmployee]) this.selectedEmployee = 0
    },
    getMetricClassifications () {
      this.axios.get('/api/metrics/classifications', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.classifications = []
        const onlyEnabled = res.data.filter(item => item.Enabled)
        for (let i = 0; i < onlyEnabled.length; i++) {
          this.classifications.push({
            ...onlyEnabled[i],
            assigns: [],
            listOfMetrics: []
          })
          this.getMetricClassificationAssigns(this.classifications[i].assigns, onlyEnabled[i].Classification_ID)
          this.getMetrics(this.classifications[i].listOfMetrics, onlyEnabled[i].Classification_ID)
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getMetrics (metrics, classificationID) {
      this.axios.get(`/api/metrics/get_metrics/${classificationID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        for (let i = 0; i < res.data.length; i++) {
          metrics.push({
            ...res.data[i],
            valueByEmployee: {}
          })
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getMetricClassificationAssigns (assigns, classificationID) {
      this.axios.get(`/api/metrics/classification_assigns/${classificationID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        for (let i = 0; i < res.data.length; i++) {
          assigns.push(res.data[i].Employee_Status_ID)
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getEmployeeMetricsValue () {
      this.axios.get(`/api/metrics/get_values_by_summary_id/${this.summary.Summary_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.setEmployeeMetricsValue(res.data)
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getEmployeeAtTheProject (projectID) {
      this.axios.get(`/api/metrics/get_all_employee_at_the_project/${projectID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.employeeAtTheProject = []
        for (let i = 0; i < res.data.length; i++) {
          this.employeeAtTheProject.push({
            ...res.data[i]
          })
        }
        setTimeout(() => {
          if (this.summary) {
            this.getEmployeeMetricsValue()
          } else {
            this.setEmployeeMetricsValue()
          }
        })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    saveMetricSummary () {
      const body = {
        summary: {
          Name: this.summaryTitle,
          Date_From: this.dates[0],
          Date_To: this.dates[1],
          Project_ID: this.selectedProject,
          Summary_ID: this.summary ? this.summary.Summary_ID : null
        },
        values: []
      }
      for (let i = 0; i < this.classifications.length; i++) {
        const listOfMetrics = this.classifications[i].listOfMetrics
        for (let j = 0; j < listOfMetrics.length; j++) {
          const values = listOfMetrics[j].valueByEmployee
          for (const key in values) {
            if (typeof +values[key] === 'number') {
              body.values.push({
                Employee_ID: key,
                Value: values[key],
                PR_Matrix_ID: listOfMetrics[j].PR_Matrix_ID
              })
            }
          }
        }
      }
      if (this.summary) {
        this.axios.put('/api/metrics/update_summary', body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.$store.dispatch('setSuccess', { successMsg: 'Summary Metrics successfully updated' })
          this.$emit('updateSummary')
          this.show = false
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      } else {
        this.axios.post('/api/metrics/create_summary', body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.$store.dispatch('setSuccess', { successMsg: 'Summary Metrics successfully created' })
          this.$emit('updateSummary')
          this.show = false
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      }
    }
  }
}
</script>
